<template>
	<div id="app">
		<div id="nav">
			<div class="menu-icons">
				<router-link to="/products">
					<b-tooltip label="Products" position="is-right">
						<ios-pricetags-icon w="32px" h="32px" />
					</b-tooltip>
				</router-link>
			</div>

			<div class="menu-icons">
				<b-tooltip label="Direct Purchase" position="is-right">
					<router-link to="/direct-purchase">
						<ios-add-circle-outline-icon w="32px" h="32px" />
					</router-link>
				</b-tooltip>
			</div>

			<div class="menu-icons">
				<b-tooltip label="Purchase Order" position="is-right">
					<router-link to="/po">
						<ios-list-icon w="32px" h="32px" />
					</router-link>
				</b-tooltip>
			</div>

			<div class="menu-icons">
				<b-tooltip label="Purchase Invoice" position="is-right">
					<router-link to="/pi">
						<ios-checkbox-outline-icon w="32px" h="32px" />
					</router-link>
				</b-tooltip>
			</div>

			<div class="menu-icons">
				<b-tooltip label="Returns" position="is-right">
					<router-link to="/returns">
						<ios-backspace-icon w="32px" h="32px" />
					</router-link>
				</b-tooltip>
			</div>

			<div class="menu-icons">
				<b-tooltip label="Product Transfer" position="is-right">
					<router-link to="/product-transfer">
						<ios-code-icon w="32px" h="32px" />
					</router-link>
				</b-tooltip>
			</div>

			<div class="menu-icons">
				<b-tooltip label="Stock Transfer" position="is-right">
					<router-link to="/warehouse/stock-transfer">
						<ios-sync-icon w="32px" h="32px" />
					</router-link>
				</b-tooltip>
			</div>

			<div class="menu-icons">
				<b-tooltip label="Logout" position="is-right">
					<router-link to="/logout">
						<ios-log-out-icon w="32px" h="32px" />
					</router-link>
				</b-tooltip>
			</div>
		</div>
		<div><router-view /></div>
	</div>
</template>

<script>
// @ is an alias to /src

export default {
	name: 'App',
	data: function() {
		return {}
	},
	mounted: async function() {
		// Set auth if exist
		if (this.$store.state.auth) {
			this.$axios.defaults.headers.common['Authorization'] = 'Token ' + this.$store.state.auth
		}
	}
}
</script>

<style>
@import url('https://cdn.materialdesignicons.com/2.5.94/css/materialdesignicons.min.css');

@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600&display=swap');

body {
	margin: 0;
}

#app {
	font-family: 'Poppins', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #1c2d40;
	display: grid;
	grid-template-columns: 50px 1fr;
	grid-gap: 20px;
	width: 100%;
	height: 100vh;
	background-color: #f6f9fd;
}

#nav {
	background-color: #000;
	color: #fff;
}

#nav .menu-icons {
	margin-top: 20px;
	color: #fff;
}

#nav a {
	color: #fff;
}

.mainWrapper {
	padding: 20px;
}

body .mainWrapper input {
	-webkit-box-shadow: 0px 0px 5px 0px rgb(201, 238, 250);
	-moz-box-shadow: 0px 0px 5px 0px rgba(201, 238, 250, 1);
	box-shadow: 0px 0px 5px 0px rgba(201, 238, 250, 1);
	border: 1px solid #d5e3f5;
	background-color: #fff;
	font-weight: 500;
	font-size: 13px;
	height: 40px;
}

body h1 {
	font-size: 21px;
	font-weight: bold;
	color: #333;
	margin: 20px 0;
	text-align: left;
}

.paginationWrapper {
	margin: auto;
}

.pagination {
	height: 70px;
	width: 400px;
	margin: auto;
	padding: 5px 20px;
	font-weight: bold;
}

body .list {
	-webkit-box-shadow: 0px 0px 5px 0px rgb(201, 238, 250);
	-moz-box-shadow: 0px 0px 5px 0px rgba(201, 238, 250, 1);
	box-shadow: 0px 0px 5px 0px rgba(201, 238, 250, 1);
	border: 1px solid #d5e3f5;
	background-color: #fff;
}

.pagination a {
	color: #999;
	padding: 6px 12px;
	line-height: 1.42;
}

.pagination .active a {
	color: #999;
	padding: 0;
	outline: 0;
}

.pagination li.active {
	padding: 10px;
	border-radius: 20px;
	background-color: #810369;
	height: 40px;
	width: 40px;
}

.pagination li.active a {
	color: #fff;
	font-weight: bolder;
}

.big-button {
	padding: 20px 20px;
	background-color: #ff4343;
	color: #fff;
	font-weight: 600;
	border: none;
	font-size: 12px;
	border-radius: 10px;
	cursor: pointer;
	outline: 0;
}

.general-search {
	margin: auto;
	display: grid;
	grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
	grid-gap: 10px;
	text-align: left;
	margin-bottom: 2em;
}

.hyperlink {
	cursor: pointer;
}

.links {
	text-align: left;
	margin: 20px 0;
}

.links a {
	color: #fff;
}
</style>
